import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
	openFinanceSlideout,
	setActiveDrawer,
} from '../../actions/lister-actions';
import TRANSLATIONS from '../../translations/translations@default.json';

const InterestFreeCreditButton = ({
	financeData,
	classes,
	fullTitle,
	NowPrice,
	MemberPrice,
	Code,
	ColourId,
	financePromotions,
	State,
	UpfrontPricing = {
		HasData: false,
		HasMemberData: false
	},
}) => {
	const dispatch = useDispatch();

	const { AnnualMembershipFee } = useSelector((state) => state.featureSwitches);
	const { UseUpfrontPricingAmount } = useSelector(
		(state) => state.featureSwitches
	);

	return (
		<button
			type="button"
			aria-label="Interest Free Finance Promotion"
			className={`${classes} relative z-10 p-0 w-full mt-2 lg:mt-4 bg-transparent`}
			onClick={() => {
				dispatch(
					openFinanceSlideout({
						productId: ColourId,
						productSku: Code,
						nowPrice: NowPrice,
						memberPrice: MemberPrice,
						annualMembershipFee: AnnualMembershipFee,
						financePromotionCodes: financePromotions
							? financePromotions.map((p) => p.PromotionCode)
							: [],
						isInStock: State !== 'OutOfStock',
						memberUpfrontPaymentAmount:
							UpfrontPricing?.MemberUpfrontPaymentAmount,
						upfrontPaymentAmount: UpfrontPricing?.UpfrontPaymentAmount,
						upfrontPaymentPercentage: UpfrontPricing?.UpfrontPaymentPercentage,
						upfrontPaymentsEnabled: UseUpfrontPricingAmount,
					})
				);
			}}
			data-tag-name="finance-interest-free-button"
			data-tag-finance-type="finance-interest-free-button"
			data-tag-product={fullTitle}
			data-testid="finance-interest-free">
			<div className="flex flex-row items-center bg-steam p-1 rounded-sm text-title-sm text-xs">
				<span className="px-2 flex-grow">
					{`${TRANSLATIONS.productList.productCard.financeRestyle.interestFree} ${TRANSLATIONS.productList.productCard.financeRestyle.instalmentPlan}`}
				</span>
				<i className="ico ico-chevron-right text-xl text-cta-action" />
			</div>
		</button>
	);
};

export default InterestFreeCreditButton;
